/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { PacienteCitasService } from './services/paciente-citas.service';
import { PacienteIncidenciasService } from './services/paciente-incidencias.service';
import { PacienteIncidenciasTecnicasService } from './services/paciente-incidencias-tecnicas.service';
import { PacienteArticulosService } from './services/paciente-articulos.service';
import { PacientesService } from './services/pacientes.service';
import { DoctorMedicosService } from './services/doctor-medicos.service';
import { AccesibilidadService } from './services/accesibilidad.service';
import { DoctorProgramasService } from './services/doctor-programas.service';
import { PacienteNotificacionesService } from './services/paciente-notificaciones.service';
import { PacientePantallaDeInicioService } from './services/paciente-pantalla-de-inicio.service';
import { PacienteFarmacosService } from './services/paciente-farmacos.service';
import { PacienteAnaliticasService } from './services/paciente-analiticas.service';
import { DoctorInformacionAdicionalService } from './services/doctor-informacion-adicional.service';
import { DoctorPacientesService } from './services/doctor-pacientes.service';
import { DoctorEncuestasService } from './services/doctor-encuestas.service';
import { DoctorAlertasService } from './services/doctor-alertas.service';
import { PacienteEncuestasService } from './services/paciente-encuestas.service';
import { SeedersService } from './services/seeders.service';
import { DoctorFarmacosService } from './services/doctor-farmacos.service';
import { ProgramaParametrosService } from './services/programa-parametros.service';
import { PacienteProgramasService } from './services/paciente-programas.service';
import { UsuariosService } from './services/usuarios.service';
import { MedicosConfiguracionService } from './services/medicos-configuracion.service';
import { CitasConfirmacionService } from './services/citas-confirmacion.service';
import { PrincipiosActivosService } from './services/principios-activos.service';
import { DoctorPrincipiosActivosService } from './services/doctor-principios-activos.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    PacienteCitasService,
    PacienteIncidenciasService,
    PacienteIncidenciasTecnicasService,
    PacienteArticulosService,
    PacientesService,
    DoctorMedicosService,
    AccesibilidadService,
    DoctorProgramasService,
    PacienteNotificacionesService,
    PacientePantallaDeInicioService,
    PacienteFarmacosService,
    PacienteAnaliticasService,
    DoctorInformacionAdicionalService,
    DoctorPacientesService,
    DoctorEncuestasService,
    DoctorAlertasService,
    PacienteEncuestasService,
    SeedersService,
    DoctorFarmacosService,
    ProgramaParametrosService,
    PacienteProgramasService,
    UsuariosService,
    MedicosConfiguracionService,
    CitasConfirmacionService,
    PrincipiosActivosService,
    DoctorPrincipiosActivosService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
